
import Vue from "vue";
import { Maintenance, MaintenanceItem } from "@/@core/maintenance";

export default Vue.extend({
  data() {
    return {
      futureMaintenance: undefined as MaintenanceItem | undefined,
      maintenanceInfo: null as string | null,
    };
  },
  async mounted() {
    this.futureMaintenance = await Maintenance.getFuture();
    this.setMaintenanceInfo();
  },
  methods: {
    setMaintenanceInfo() {
      if (this.futureMaintenance) {
        this.maintenanceInfo = this.futureMaintenance.infoMessage[this.$i18n.locale === "fr" ? "fr" : "nl"];
      }
    },
  },
  watch: {
    "$i18n.locale": {
      handler() {
        this.setMaintenanceInfo();
      },
    },
  },
});
